(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-hero')) {
    class CmHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.cm-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.cm-hero__dot'));
        this.index = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 6000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced && this.slides.length > 1;
        this.style.setProperty('--cm-hero-speed', this.speed + 'ms');

        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.go, 10), true)));
        this.querySelectorAll('.cm-hero__arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.index + parseInt(btn.dataset.dir, 10), true))
        );

        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());

        let startX = null;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 45) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
        });

        document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.play()));
        this.classList.add('is-ready');
        this.play();
      }

      disconnectedCallback() {
        this.pause();
      }

      go(i, user) {
        const n = this.slides.length;
        if (!n) return;
        const next = ((i % n) + n) % n;
        this.slides.forEach((s, k) => {
          s.classList.toggle('is-active', k === next);
          if (k === next) {
            s.removeAttribute('aria-hidden');
          } else {
            s.setAttribute('aria-hidden', 'true');
          }
        });
        this.dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === next);
          d.setAttribute('aria-selected', k === next ? 'true' : 'false');
        });
        this.index = next;
        if (user) {
          this.pause();
          this.play();
        }
      }

      play() {
        if (!this.autoplay || this.timer) return;
        this.classList.add('is-playing');
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      pause() {
        clearInterval(this.timer);
        this.timer = null;
        this.classList.remove('is-playing');
      }
    }
    customElements.define('cm-hero', CmHero);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const hero = event.target.closest('cm-hero');
    if (!hero || !event.target.classList.contains('cm-hero__slide')) return;
    hero.go(parseInt(event.target.dataset.index, 10), true);
    hero.pause();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
